<script lang="ts" setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import TextFieldWithIconGroup from "@/components/molecules/form/TextFieldWithIconGroup.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { useLoader } from "@/utils/loader";
import { useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";

const resetPasswordBeforeLoginRoute = { name: "ResetPasswordBeforeLogin" };

const modal = useModal();
const loader = useLoader();
const customRouter = useCustomRouter();
const router = useRouter();

const password = ref("");

async function login() {
  try {
    loader.show();
    await workerLogin();
    await customRouter.replaceIgnoreError({ name: "Search" });
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any;
    // phoneNumberもしくはserviceNameが不正な場合
    if (!err.response || !err.response.data) {
      await modal.msgBoxOk("不正な操作です", {
        centered: true
      });
      await customRouter.replaceIgnoreError({ name: "Welcome" });
    }

    // 入力内容が正しくない場合
    if (err.response.data.nonFieldErrors) {
      await modal.msgBoxOk(err.response.data.nonFieldErrors[0], {
        centered: true
      });
      return;
    }

    await modal.msgBoxOk("不明なエラーが発生しました", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

function workerLogin() {
  const body = {
    password: password.value,
    phoneNumber: authStore.temporaryPhoneNumber as string
  };
  return authService.workerLogin(body);
}

function onClickBack() {
  router.back();
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      認証完了
    </Header>
    <div class="my-5 mx-4">
      <div class="p-4 text-center">
        <AuthCompletion />
      </div>
      <p class="mb-4 text-weight-500 text-center">
        携帯電話番号の認証が完了しました！<br />
        設定済みのパスワードで<br />
        ログインしてください
      </p>
      <CustomValidationObserver
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
      >
        <BForm @submit.stop.prevent="handleSubmit(login)">
          <ValidationProvider
            v-slot="validationState"
            name="パスワード"
            rules="required|min:8|max:500"
            v-model="password"
          >
            <TextFieldWithIconGroup
              v-model="password"
              placeholder="パスワード"
              type="password"
              innerIconType="password"
              class="mb-4"
              :validation-state="validationState"
            />
          </ValidationProvider>

          <AppButton block @click="handleSubmit(login)">
            ログイン
          </AppButton>
        </BForm>
      </CustomValidationObserver>
    </div>
    <div class="pb-5 text-center">
      <RouterLink :to="resetPasswordBeforeLoginRoute">
        <u class="text-size-14 text-mild">
          パスワードを忘れた場合
        </u>
      </RouterLink>
    </div>
    <BlockBack />
  </div>
</template>
